module.exports = __webpack_public_path__ + "media/images/flags/4x3/tto-828de8023793bd34fe0e36c1b09e4785.svg";